<!-- Custom preview element -->
<div class="{{cdkDragPreviewClass}}">
  <div class="cdk-drag-preview_sp2-column" [ngClass]="{'pb-sp2-column': type === 'pb'}">
    <app-issue class="cdk-drag-preview-pb pb-issue parent-issue-container"
      [issue]="issue"
      [inheritedIssueType]="issue.issueType"
    >
    </app-issue>
    <div class="cdk-drag-preview-sp2 issue-column">
      <app-issue class="issue-list-element parent-issue-container"
        [issue]="issue"
        [inheritedIssueType]="issue.issueType"
      >
      </app-issue>
    </div>
  </div>
</div>

